import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { Pressable, View } from 'react-native';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { StateConfigContext } from '../../providers/state-config-provider';
import { getTestId } from '../../utils';
import { Typography } from '../typography';
import { getDonutGraphProps, getDonutGraphStyles } from './DonutGraphStyles';
import { Pie } from './components/DonutChart';
import { getPercentage } from './components/DonutChartUtils';
var CANVAS_SIZE = 200;
export var DonutGraph = props => {
  var stateContext = useContext(StateConfigContext);
  var donutGraphProps = getDonutGraphProps(props, stateContext);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var donutGraphStyles = getDonutGraphStyles(isLargeScreen);
  var pieData = donutGraphProps.data,
    _donutGraphProps$show = donutGraphProps.showBigNumber,
    showBigNumber = _donutGraphProps$show === void 0 ? false : _donutGraphProps$show,
    _donutGraphProps$show2 = donutGraphProps.showDetails,
    showDetails = _donutGraphProps$show2 === void 0 ? false : _donutGraphProps$show2,
    _donutGraphProps$colu = donutGraphProps.columnNumber,
    columnNumber = _donutGraphProps$colu === void 0 ? 1 : _donutGraphProps$colu,
    _donutGraphProps$test = donutGraphProps.testID,
    testID = _donutGraphProps$test === void 0 ? 'DonutGrpah' : _donutGraphProps$test,
    detailsContainerStyle = donutGraphProps.detailsContainerStyle;
  var getInnerText = (index, dataAsset) => index < 0 ? {
    index: -1,
    text: showBigNumber && "Javascript Skills %100"
  } : {
    index,
    name: "" + dataAsset[index].name,
    number: "" + dataAsset[index].number
  };
  var _useState = useState(getInnerText(-1, pieData)),
    selectedPie = _useState[0],
    setSelectedPie = _useState[1];
  var onPieItemSelected = newIndex => () => {
    setSelectedPie(getInnerText(newIndex === (selectedPie === null || selectedPie === void 0 ? void 0 : selectedPie.index) ? -1 : newIndex, pieData));
  };
  var pieDataChunks = [];
  var chunkSize = Math.ceil((pieData === null || pieData === void 0 ? void 0 : pieData.length) / columnNumber);
  if ((pieData === null || pieData === void 0 ? void 0 : pieData.length) < columnNumber) {
    chunkSize = 1;
  } else if (columnNumber === 1) {
    chunkSize = pieData === null || pieData === void 0 ? void 0 : pieData.length;
  }
  for (var i = 0; i < (pieData === null || pieData === void 0 ? void 0 : pieData.length); i += chunkSize) {
    pieDataChunks.push(pieData === null || pieData === void 0 ? void 0 : pieData.slice(i, i + chunkSize));
  }
  return _jsxs(View, Object.assign({
    style: donutGraphStyles.donutGraphContainer
  }, getTestId(testID), {
    children: [_jsx(View, Object.assign({
      style: donutGraphStyles.donutGraphCircle
    }, getTestId(testID, 'circle'), {
      children: _jsx(Pie, Object.assign({
        pieSize: CANVAS_SIZE * 0.9,
        onItemSelected: onPieItemSelected,
        size: CANVAS_SIZE,
        data: pieData,
        value: selectedPie
      }, donutGraphProps))
    })), showDetails && _jsx(View, Object.assign({
      style: [donutGraphStyles.showDetailsContainer, detailsContainerStyle]
    }, getTestId(testID, 'showDetails'), {
      children: pieDataChunks === null || pieDataChunks === void 0 ? void 0 : pieDataChunks.map((chunk, columnIndex) => _jsx(View, Object.assign({
        style: donutGraphStyles === null || donutGraphStyles === void 0 ? void 0 : donutGraphStyles.columnContainer
      }, {
        children: chunk === null || chunk === void 0 ? void 0 : chunk.map((item, index) => _jsxs(Pressable, Object.assign({
          onPress: onPieItemSelected(columnIndex * chunkSize + index),
          style: donutGraphStyles.showDetailsItem
        }, {
          children: [_jsx(View, {
            style: [{
              backgroundColor: item === null || item === void 0 ? void 0 : item.color
            }, donutGraphStyles.showDetailsItemColor]
          }), _jsx(Typography, {
            text: item === null || item === void 0 ? void 0 : item.name,
            type: "title-para-lg"
          }), _jsx(Typography, {
            text: (item === null || item === void 0 ? void 0 : item.number) + " [" + getPercentage(pieData, parseInt(item === null || item === void 0 ? void 0 : item.number)) + "%]",
            type: "body-para-sm",
            style: {
              marginLeft: 4
            }
          })]
        }), (item === null || item === void 0 ? void 0 : item.name) + "_" + index))
      }), "column_" + columnIndex))
    }))]
  }));
};